var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-block"},[_c('home-block-title',{attrs:{"title":"专题栏目","linkText":"更多","link":{
      path: '/commonMore',
      query: {
        commonMoreName: '专题栏目',
        showType: 'card',
        activeMenu: '专题栏目'
      }
    }}}),_c('div',{staticClass:"list special-list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"img-wrap",on:{"click":function($event){return _vm.showInfo(item)}}},[_c('img',{attrs:{"src":item.readImageUrl,"alt":""}})]),_c('div',{staticClass:"title"},[_c('div',{staticClass:"left",on:{"click":function($event){return _vm.showInfo(item)}}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.readName))])]),_c('div',{staticClass:"right"},[_vm._v(" "+_vm._s(_vm.formatDate(item.infoTime, "Y-M-D"))+" ")])])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }